// Vendor Libs
import {difference, union} from 'lodash';

const initialState = {
    active: false,
    childFormName: null,
    label: '',
    lastId: null,
    massActionName: null,
    selectAll: false,
    showMessage: false,
    submitted: false,
    targets: [],
};

const actions = {
    MASS_ACTION_SET_SELECT_ALL: (state, {massActionName, selectAll}) => ({
        ...state,
        massActionName,
        selectAll,
        targets: state.massActionName === massActionName ? state.targets : [],
    }),

    MASS_ACTION_SET_CHILD_FORM_DATA: (state, {childFormName, label, showMessage}) => ({
        ...state,
        childFormName,
        label,
        showMessage,
        submitted: childFormName ? state.submitted : false,
    }),

    MASS_ACTION_SET_LAST_ID: (state, {lastId}) => ({
        ...state,
        lastId,
    }),

    MASS_ACTION_SET_ACTIVE: (state, {massActionName, active}) => ({
        ...state,
        active,
        massActionName,
        selectAll: state.massActionName === massActionName ? state.selectAll : false,
        targets: state.massActionName === massActionName ? state.targets : [],
    }),

    MASS_ACTION_SET_TARGETS: (state, {massActionName, targets}) => ({
        ...state,
        massActionName,
        selectAll: state.massActionName === massActionName ? state.selectAll : false,
        targets,
    }),

    MASS_ACTION_ADD_TARGETS: (state, {massActionName, targets}) => ({
        ...state,
        massActionName,
        selectAll: state.massActionName === massActionName ? state.selectAll : false,
        targets: state.massActionName === massActionName ? union(state.targets, targets) : targets,
    }),

    MASS_ACTION_REMOVE_TARGETS: (state, {massActionName, targets}) => ({
        ...state,
        massActionName,
        selectAll: state.massActionName === massActionName ? state.selectAll : false,
        targets: state.massActionName === massActionName ? difference(state.targets, targets) : [],
    }),

    MASS_ACTION_CLEAR_TARGETS: (state, {massActionName}) => ({
        ...state,
        massActionName,
        selectAll: state.massActionName === massActionName ? state.selectAll : false,
        targets: [],
    }),

    MASS_ACTION_SUBMIT: (state) => ({
        ...state,
        submitted: true,
    }),

    MASS_ACTION_RESET: () => initialState,
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
